export const stripHtmlTagsFromText = (rawText: string): string => {
  const strippedText = rawText.replace(/(<([^>]+)>)/gi, ' ');
  return strippedText;
}